import { RawDataSource } from '@felicity/data-management';

/**
 * Data source for loading and storing identity role records
 */
export default class RoleDataSource extends RawDataSource {
  uri = '/api/Users/Role';

  sortField = 'name';
}
